module.exports = {
    calendarTheme: {
        color: 'gray',
        isDark: false,
        container: {
            light:
      'f-text-bc-36 vc-bg-white vc-border vc-border-gray-42 vc-rounded-lg',
            dark:
      'f-text-bc-32 f-bg-bc-36 vc-border vc-border-gray-40 vc-rounded-lg',
        },
        header: {
            light: 'f-text-bc-36',
            dark: 'f-text-bc-32',
        },
        title: {
            light: 'vc-text-lg f-text-bc-800 vc-font-semibold hover:vc-opacity-75',
            dark: 'vc-text-lg f-text-bc-100 vc-font-semibold hover:vc-opacity-75',
        },
        arrows: {
            light:
      'f-text-bc-42 vc-rounded vc-border-2 vc-border-transparent hover:vc-opacity-50 hover:f-bg-bc-32 focus:vc-border-gray-300',
            dark:
      'vc-text-white vc-rounded vc-border-2 vc-border-transparent hover:vc-opacity-50 focus:vc-border-gray-40',
        },
        weekdays: {
            light: 'vc-text-sm vc-font-bold f-text-bc-42',
            dark: 'vc-text-sm vc-font-bold vc-text-{color}-32',
        },
        navPopoverContainer: {
            light:
      'vc-rounded-lg vc-text-sm vc-font-semibold f-text-bc-36 f-bg-bc-42 f-border-1 vc-border-gray-40 vc-p-1 vc-shadow',
            dark:
      'vc-rounded-lg vc-text-sm vc-font-semibold f-text-bc-800 vc-bg-white vc-border vc-border-gray-100 vc-p-1 vc-shadow',
        },
        navTitle: {
            light:
      'vc-text-{color}-100 vc-font-bold vc-leading-snug vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:f-bg-bc-36 focus:vc-border-{color}-600',
            dark:
      'f-text-bc-36 vc-font-bold vc-leading-snug vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:f-bg-bc-32 focus:vc-border-{color}-42',
        },
        navArrows: {
            light:
      'vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:f-bg-bc-36 focus:vc-border-{color}-600',
            dark:
      'vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:f-bg-bc-32 focus:vc-border-{color}-42',
        },
        navCell: {
            light:
      'vc-w-12 vc-font-semibold vc-cursor-pointer vc-text-center vc-leading-snug vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:f-bg-bc-36 hover:vc-shadow-inner hover:vc-text-white focus:vc-border-{color}-600',
            dark:
      'vc-w-12 vc-font-semibold vc-cursor-pointer vc-text-center vc-leading-snug vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:f-bg-bc-32 hover:f-text-bc-36 focus:vc-border-{color}-42',
        },
        navCellInactive: 'vc-border-transparent',
        navCellInactiveCurrent: {
            light: 'vc-text-{color}-100 vc-font-bold vc-border-{color}-100',
            dark: 'vc-text-{color}-600 vc-font-bold vc-border-{color}-500',
        },
        navCellActive: {
            light:
      'vc-bg-{color}-100 f-text-bg-36 vc-border-transparent vc-font-bold vc-shadow',
            dark:
      'vc-bg-{color}-500 vc-text-white vc-border-transparent vc-font-bold vc-shadow',
        },
        dayNotInMonth: 'vc-opacity-0 vc-pointer-events-none',
        dayContent:
    'vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold vc-rounded-full',
        dayContentDisabled: {
            light: 'f-text-bc-42',
            dark: 'f-text-bc-32',
        },
        dayPopoverContainer: {
            light:
      'vc-rounded vc-text-xs vc-text-white vc-font-medium f-bg-bc-40 vc-border vc-border-gray-40 vc-px-2 vc-py-1 vc-shadow',
            dark:
      'vc-rounded vc-text-xs f-text-bc-36 vc-font-medium vc-bg-white vc-border vc-border-gray-32 vc-px-2 vc-py-1 vc-shadow',
        },
        dayPopoverHeader: {
            light: 'vc-text-xs f-text-bc-32 vc-font-semibold',
            dark: 'vc-text-xs f-text-bc-40 vc-font-semibold',
        },
        highlightBaseFillMode: 'light',
        highlightStartEndFillMode: 'solid',
        highlightStartEndClass: 'vc-rounded-full',
        bgLow: {
            light: 'vc-bg-white vc-border-2 vc-border-{color}-40',
            dark: 'f-bg-bc-36 vc-border-2 vc-border-{color}-32',
        },
        bgAccentLow: {
            light: 'f-bg-bc-32',
            dark: 'vc-bg-{color}-800 vc-opacity-75',
        },
        bgAccentHigh: {
            light: 'f-bg-bc-36',
            dark: 'f-bg-bc-36',
        },
        contentAccent: {
            light: 'vc-font-bold f-text-bg-45',
            dark: 'vc-font-bold f-text-bg-30',
        },
        contentAccentContrast: 'vc-font-bold f-text-bg-45',
        datePickerInput:
    'vc-appearance-none vc-text-base f-text-bc-800 vc-bg-white vc-border vc-border-gray-42 vc-rounded vc-w-full vc-py-2 vc-px-3 vc-leading-tight focus:vc-outline-none focus:vc-shadow',
        datePickerInputDrag:
    'vc-appearance-none vc-text-base f-text-bc-500 vc-bg-white vc-border vc-border-gray-42 vc-rounded vc-w-full vc-py-2 vc-px-3 vc-leading-tight focus:vc-outline-none focus:vc-shadow',
    },
};
